import { useEffect, useState } from "react";
import { Button, Card, Typography } from "antd";
import { useIntl } from "react-intl";
import { masteruri } from "../../config";
import { cardmargin } from "../CSSReferences";
import { SetupOffer, downloadPath, offerPath, parseOffer, sizeLabel } from "./vodin_download";

// Public download of the newest activated Vodin release (07.10.2026). Shows
// nothing while the hub has none to offer, so the login page looks as before.
export function VodinDownload() {
    const intl = useIntl();
    const [offer, setOffer] = useState<SetupOffer | null>(null);

    useEffect(() => {
        let current = true;
        fetch(offerPath(masteruri))
            .then(response => response.ok ? response.json() : null)
            .then(json => { if (current) setOffer(parseOffer(json)); })
            .catch(() => { if (current) setOffer(null); });
        return () => { current = false; };
    }, []);

    if (offer === null) {
        return null;
    }
    return (
        <Card style={cardmargin} size="small"
              title={intl.formatMessage({ id: "VodinDownload:Title", defaultMessage: "Download Vodin" })}>
            <Button type="primary" href={downloadPath(masteruri)} download={offer.fileName}>
                {intl.formatMessage({ id: "VodinDownload:Button", defaultMessage: "Vodin {version} ({size})" },
                    { version: offer.version, size: sizeLabel(offer.size) })}
            </Button>
            <Typography.Paragraph type="secondary" style={{ marginTop: 8, marginBottom: 0 }}>
                SHA-256: <Typography.Text code copyable style={{ wordBreak: "break-all" }}>{offer.sha256}</Typography.Text>
            </Typography.Paragraph>
        </Card>
    );
}
